package serialized

import it.neckar.lizergy.model.project.previews.ResolvedProjectPreview
import kotlinx.serialization.Serializable

/**
 * Contains the serialized search for projects result
 */
@Serializable
data class SearchForProjectsResult(
  /**
   * The projects that match the search string
   */
  val projects: List<ResolvedProjectPreview>,
) {


  companion object {
    /**
     * Does not contain any values
     */
    val empty: SearchForProjectsResult = SearchForProjectsResult(emptyList())
  }
}
